import { ActionStatus } from '@/core/types/enums/action-status.enum'
import { addToCart } from '@/features/cart/providers/server'
import { addToast } from '@heroui/react'
import { useTransition } from 'react'
import { UpdateCartModel } from '../model/update-cart.model'

export function useUpdateCart() {
  const [isPending, startTransition] = useTransition()

  const onUpdateCart = (data: UpdateCartModel) => {
    return new Promise((resolve, reject) => {
      startTransition(async () => {
        const { items, delete_item_ids } = data

        const { error, status } = await addToCart(
          items?.length ? data : { delete_item_ids },
        )
        if (error) {
          addToast({
            title: error,
            color: 'danger',
          })
        }

        if (status === ActionStatus.SUCCESS) resolve(null)
        if (status === ActionStatus.ERROR) reject(error)
      })
    })
  }

  return {
    isPending,
    onUpdateCart,
  }
}
